import styles from './ProductTags.module.scss';

const ProductTags = (props) => {
	const { fields, menuTags, productTags, isDisabled } = props;
	const handleClick = (e) => {
		props.handleClick(e);
	};
	const generateTags = (allTags, includedTags, type) => {
		return allTags.map((tag) => {
			const index = includedTags.indexOf(tag);
			const isSelected = index > -1;
			return (
				<span
					className={`${styles.tag} ${
						isSelected ? styles.selected : ''
					}`}
					onClick={handleClick}
					data-type={type}
					data-tag={tag}
				>
					{tag}
				</span>
			);
		});
	};
	return (
		<div className={`${styles.root} ${isDisabled ? styles.disabled : ''}`}>
			<div className='form-field row'>
				<label className='form-label'>Menu Tags</label>
				<div className={`${styles['tag-wrapper']}`}>
					{generateTags(menuTags, fields.menuTags, 'menu')}
				</div>
			</div>
			<div className='form-field row'>
				<label className='form-label'>Product Tags</label>
				<div className={`${styles['tag-wrapper']}`}>
					{generateTags(productTags, fields.productTags, 'product')}
				</div>
			</div>
		</div>
	);
};
ProductTags.defaultProps = {
	handleClick: () => {},
};
export default ProductTags;
